import { render, staticRenderFns } from "./TopMaisClientesCard.vue?vue&type=template&id=7cbadec2"
import script from "./TopMaisClientesCard.vue?vue&type=script&lang=js"
export * from "./TopMaisClientesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports